import React from "react"
import Link from "gatsby-link"
import styled from "styled-components"
import Helmet from "react-helmet"
import {
  TINY_SHADOW,
  TINY_BKG,
  ACTIVE_TEXT,
  SECONDARY_TEXT,
  PRIMARY_TEXT
} from "../components/consts/colors.js"
import "../css/Hide.css"

const BlogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0px 100px 0px;
  width: 100%;
  background-color: ${TINY_BKG};

  a {
    color: ${PRIMARY_TEXT};
    transition: all 200ms ease;
  }
  :hover {
    transform: translateY(-3px);
  }
`

const BlogPostPreview = styled.div`
  display: flex;
  position: relative;
  z-index: 3;
  flex-direction: column;
  align-items: flex-start;
  max-width: 750px;
  margin: 50px 0px;
  padding: 50px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 4px 10px ${TINY_SHADOW};
  transition: all 400ms ease;
  h3 {
    font-weight: 400;
  }
  h1 {
    margin-bottom: 25px;
  }
  :hover {
    transform: translateY(-3px);
    box-shadow: 0px 6px 15px ${TINY_SHADOW};
  }
  @media screen and (max-width: 768px) {
    width: 80%;
    margin: 25px 0px;
  }
  @media screen and (max-width: 615px) {
    width: 90%;
    margin: 10px 0px;
  }
`
const BlogPostInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 50px;

  p {
    color ${ACTIVE_TEXT};
  }
`

export default function Index({ data }) {
  const { edges: posts } = data.allMarkdownRemark
  return (
    <BlogWrapper>
      {posts
        .filter(post => post.node.frontmatter.title.length > 0)
        .map(({ node: post }) => {
          return (
            <Link to={post.frontmatter.path}>
              <BlogPostPreview>
                <BlogPostInfo>
                  <p>{post.frontmatter.title}</p>
                  <p>{post.frontmatter.date}</p>
                </BlogPostInfo>
                <h3>{post.frontmatter.postGreeting}</h3>
                <h1>{post.frontmatter.postTitle}</h1>
                <p>{post.frontmatter.postPreview}</p>
              </BlogPostPreview>
            </Link>
          )
        })}
    </BlogWrapper>
  )
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            postTitle
            postGreeting
            postPreview
            path
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/blog.js